const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpalaLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.19 59.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 0.24,
    y: 51.71,
    width: 0.59,
    height: 7.16
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    y: 2.44,
    width: 3.19,
    height: 41.05
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M19.94,1.92c-3.92,2.72-7.44,7.8-7.44,16.44v22.02h-6.66v3.11h9.74v-25.13c0-3.82.95-8.22,2.9-10.26v35.39h2.97V8.1c1.91,2.04,2.9,6.44,2.9,10.26v25.13h9.73v-3.11h-6.65v-22.02c0-8.64-3.55-13.72-7.48-16.44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M42.58,18.62c0,5.92-.95,9.06-2.75,11.2V8.15c1.76,1.99,2.75,4.92,2.75,10.47ZM45.74,18.62c0-9.63-3.56-15.34-9.02-16.7v41.57h3.11v-8.79c2.57-1.88,5.9-6.39,5.9-16.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M61.13,20.87h-3.44c0-7.54.55-10.89,1.72-12.98,1.17,2.09,1.72,5.44,1.72,12.98ZM70.9,43.49v-3.11h-6.62v-19.61c0-10.89-2.05-15.5-4.87-18.85-2.82,3.35-4.87,7.85-4.87,18.85v19.6h-6.64v3.12h9.79v-18.27h3.44v18.27h9.77"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M90.96,1.92c-2.82,3.35-4.87,7.85-4.87,18.85v19.61h-9.31V2.44h-3.19v41.05h15.65v-18.27h3.44v18.27h3.15v-22.72c0-10.89-2.05-15.5-4.87-18.85ZM89.24,20.87c0-7.54.55-10.89,1.72-12.98,1.17,2.09,1.72,5.44,1.72,12.98h-3.44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M4.66,51.71h.59v7.16h-.97l-1.5-5.73c-.09-.32-.15-.65-.2-1.08h-.01c0,.36.01.73.01,1.1v5.71h-.59v-7.16h.97l1.53,5.86c.06.22.11.45.19.78h.02c0-.26-.02-.54-.02-.8v-5.84"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M7.11,52.42h.95c.96,0,1.13,1.09,1.17,2.72.06,2.14-.3,3.01-1.17,3.01h-.95v-5.73ZM8.1,58.87c1.45,0,1.71-1.83,1.75-3.58.04-1.77-.19-3.58-1.86-3.58h-1.48v7.16h1.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "10.96 58.87 10.96 51.71 13.64 51.71 13.64 52.42 11.55 52.42 11.55 54.79 13.51 54.79 13.51 55.51 11.55 55.51 11.55 58.15 13.66 58.15 13.66 58.87 10.96 58.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M15.34,52.42h.62c.72-.02,1.28.14,1.28,1.3,0,1.23-.49,1.38-1.31,1.39h-.58v-2.69ZM15.34,58.87v-3.04h.36c.41,0,1.02,0,1.39-.21.58-.35.76-1.13.76-1.92,0-.57-.11-1.13-.44-1.53-.32-.4-.84-.47-1.25-.47h-1.41v7.16h.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "18.76 58.87 18.76 51.71 21.45 51.71 21.45 52.42 19.36 52.42 19.36 54.79 21.32 54.79 21.32 55.51 19.36 55.51 19.36 58.15 21.46 58.15 21.46 58.87 18.76 58.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25.16,51.71h.59v7.16h-.97l-1.5-5.73c-.09-.32-.15-.65-.2-1.08h-.01c0,.36.01.73.01,1.1v5.71h-.59v-7.16h.97l1.52,5.86c.06.22.11.45.19.78h.01c0-.26-.01-.54-.01-.8v-5.84"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M27.61,52.42h.95c.96,0,1.13,1.09,1.17,2.72.06,2.14-.3,3.01-1.17,3.01h-.95v-5.73ZM28.6,58.87c1.45,0,1.71-1.83,1.76-3.58.04-1.77-.19-3.58-1.86-3.58h-1.48v7.16h1.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "31.46 58.87 31.46 51.71 34.14 51.71 34.14 52.42 32.05 52.42 32.05 54.79 34.01 54.79 34.01 55.51 32.05 55.51 32.05 58.15 34.16 58.15 34.16 58.87 31.46 58.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M37.86,51.71h.59v7.16h-.97l-1.5-5.73c-.09-.32-.15-.65-.2-1.08h-.01c0,.36.01.73.01,1.1v5.71h-.59v-7.16h.97l1.53,5.86c.06.22.11.45.19.78h.01c0-.26-.01-.54-.01-.8v-5.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "39.23 51.71 42.61 51.71 42.61 52.42 41.22 52.42 41.22 58.87 40.62 58.87 40.62 52.42 39.23 52.42 39.23 51.71"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M48.72,51.71h1.05v7.16h-.59v-5.9c0-.31.01-.6,0-.91h-.01c-.06.42-.11.69-.17.96l-1.12,5.84h-.71l-1.12-5.93c-.05-.25-.09-.49-.16-.88h-.01c0,.31.01.62.01.93v5.88h-.59v-7.16h1.05l1.05,5.59c.06.3.09.6.11,1.06h.01c.04-.36.07-.72.14-1.07l1.07-5.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M51.01,51.71h.59v5.15c0,.56.06,1.47,1.02,1.47s1.02-.91,1.02-1.47v-5.15h.59v5.43c0,1.28-.64,1.9-1.61,1.9s-1.61-.62-1.61-1.9v-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M57.79,53.59c.04-.74-.26-1.31-.85-1.31-.87,0-.96.73-.96,1.28,0,.5.16.8.51.97.29.14.57.29.85.43,1.02.51,1.2.98,1.2,1.93,0,1.36-.64,2.15-1.67,2.15-.53,0-1.16-.2-1.47-1.14-.11-.35-.11-.93-.11-1.31h.59c-.03,1.06.12,1.73,1.02,1.73.6,0,1.02-.41,1.02-1.25,0-1.09-.33-1.1-.87-1.38-.29-.15-.77-.35-1.05-.55-.51-.34-.64-.92-.64-1.62,0-1.18.62-1.96,1.5-1.96.98,0,1.58.68,1.53,2.02h-.59"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 59.73,
    y: 51.71,
    width: 0.59,
    height: 7.16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M64.15,53.85c-.02-.85-.22-1.57-.97-1.57-1.03,0-1.04,1.96-1.04,2.9-.03.97-.04,3.14,1.04,3.14.71,0,.86-.77.93-1.56.01-.16.02-.32.04-.49h.59c-.01.14-.01.3-.03.44-.04.58-.06,1.02-.31,1.52-.28.52-.65.8-1.17.8-1.65,0-1.71-2.13-1.71-3.84,0-1.61.18-3.64,1.7-3.64,1.02,0,1.55,1.01,1.52,2.29h-.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M70.17,53.85c-.01-.85-.22-1.57-.97-1.57-1.03,0-1.04,1.96-1.04,2.9-.03.97-.04,3.14,1.04,3.14.71,0,.86-.77.93-1.56.01-.16.02-.32.04-.49h.6c-.02.14-.02.3-.03.44-.04.58-.06,1.02-.31,1.52-.28.52-.65.8-1.17.8-1.65,0-1.71-2.13-1.71-3.84,0-1.61.18-3.64,1.7-3.64,1.02,0,1.55,1.01,1.52,2.29h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M74.61,55.15c0,2.07-.16,3.17-1.15,3.17s-1.15-1.1-1.15-3.17c0-1.59.22-2.87,1.14-2.87s1.17,1.28,1.17,2.87ZM71.68,55.13c.01,1.99.2,3.9,1.77,3.9s1.76-1.92,1.77-3.9c0-1.64-.19-3.57-1.75-3.57s-1.78,1.93-1.78,3.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M79.74,51.71h1.04v7.16h-.59v-5.9c0-.31.02-.6,0-.91h-.01c-.06.42-.11.69-.16.96l-1.12,5.84h-.71l-1.13-5.93c-.05-.25-.09-.49-.16-.88h-.01c0,.31.01.62.01.93v5.88h-.59v-7.16h1.05l1.05,5.59c.06.3.09.6.11,1.06h.01c.04-.36.07-.72.14-1.07l1.07-5.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M82.66,52.42h.62c.72-.02,1.27.14,1.27,1.3,0,1.23-.49,1.38-1.31,1.39h-.58v-2.69ZM82.66,58.87v-3.04h.36c.41,0,1.02,0,1.39-.21.58-.35.76-1.13.76-1.92,0-.57-.11-1.13-.44-1.53-.32-.4-.84-.47-1.25-.47h-1.41v7.16h.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M87.98,56.09h-1.42l.71-3.81h.01l.69,3.81ZM85.37,58.87h.66l.39-2.06h1.7l.42,2.06h.66l-1.51-7.16h-.79l-1.53,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M92.62,51.71h.59v7.16h-.97l-1.5-5.73c-.09-.32-.15-.65-.2-1.08h-.01c0,.36.01.73.01,1.1v5.71h-.59v-7.16h.97l1.52,5.86c.06.22.11.45.19.78h.01c0-.26-.01-.54-.01-.8v-5.84"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 94.59,
    y: 51.71,
    width: 0.59,
    height: 7.16
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "96.53 58.87 96.53 51.71 99.22 51.71 99.22 52.42 97.13 52.42 97.13 54.79 99.09 54.79 99.09 55.51 97.13 55.51 97.13 58.15 99.23 58.15 99.23 58.87 96.53 58.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M102.57,53.59c.04-.74-.26-1.31-.85-1.31-.87,0-.96.73-.96,1.28,0,.5.17.8.51.97.29.14.57.29.85.43,1.02.51,1.2.98,1.2,1.93,0,1.36-.64,2.15-1.67,2.15-.53,0-1.16-.2-1.47-1.14-.11-.35-.11-.93-.11-1.31h.59c-.03,1.06.12,1.73,1.02,1.73.6,0,1.02-.41,1.02-1.25,0-1.09-.33-1.1-.87-1.38-.29-.15-.77-.35-1.05-.55-.51-.34-.64-.92-.64-1.62,0-1.18.62-1.96,1.5-1.96.98,0,1.58.68,1.52,2.02h-.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M108.41,56.09h-1.42l.71-3.81h.02l.69,3.81ZM105.8,58.87h.66l.39-2.06h1.7l.42,2.06h.66l-1.51-7.16h-.79l-1.53,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M112.68,53.59c.04-.74-.26-1.31-.85-1.31-.87,0-.96.73-.96,1.28,0,.5.17.8.51.97.29.14.57.29.85.43,1.02.51,1.2.98,1.2,1.93,0,1.36-.64,2.15-1.67,2.15-.53,0-1.16-.2-1.47-1.14-.11-.35-.11-.93-.11-1.31h.59c-.03,1.06.12,1.73,1.02,1.73.6,0,1.02-.41,1.02-1.25,0-1.09-.33-1.1-.87-1.38-.29-.15-.77-.35-1.05-.55-.51-.34-.64-.92-.64-1.62,0-1.18.62-1.96,1.5-1.96.98,0,1.58.68,1.53,2.02h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M116.79,53.59c.04-.74-.26-1.31-.85-1.31-.87,0-.96.73-.96,1.28,0,.5.16.8.51.97.29.14.57.29.85.43,1.02.51,1.2.98,1.2,1.93,0,1.36-.64,2.15-1.67,2.15-.53,0-1.16-.2-1.47-1.14-.11-.35-.11-.93-.11-1.31h.59c-.03,1.06.12,1.73,1.02,1.73.6,0,1.02-.41,1.02-1.25,0-1.09-.33-1.1-.87-1.38-.29-.15-.77-.35-1.05-.55-.51-.34-.64-.92-.64-1.62,0-1.18.62-1.96,1.5-1.96.98,0,1.58.68,1.53,2.02h-.59"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M121.37,55.15c0,2.07-.16,3.17-1.15,3.17s-1.14-1.1-1.15-3.17c0-1.59.22-2.87,1.14-2.87s1.17,1.28,1.17,2.87ZM118.45,55.13c.01,1.99.2,3.9,1.77,3.9s1.76-1.92,1.77-3.9c0-1.64-.19-3.57-1.75-3.57s-1.78,1.93-1.78,3.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M125.53,53.85c-.01-.85-.22-1.57-.97-1.57-1.03,0-1.05,1.96-1.05,2.9-.03.97-.04,3.14,1.05,3.14.71,0,.86-.77.93-1.56.01-.16.02-.32.04-.49h.59c-.01.14-.01.3-.03.44-.04.58-.06,1.02-.32,1.52-.28.52-.65.8-1.17.8-1.65,0-1.71-2.13-1.71-3.84,0-1.61.18-3.64,1.7-3.64,1.02,0,1.55,1.01,1.52,2.29h-.59"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 127.33,
    y: 51.71,
    width: 0.59,
    height: 7.16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M131.43,56.09h-1.42l.71-3.81h.01l.7,3.81ZM128.82,58.87h.66l.39-2.06h1.7l.42,2.06h.66l-1.51-7.16h-.79l-1.53,7.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#fff"
    },
    points: "132.56 51.71 135.93 51.71 135.93 52.42 134.54 52.42 134.54 58.87 133.95 58.87 133.95 52.42 132.56 52.42 132.56 51.71"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    x: 136.85,
    y: 51.71,
    width: 0.59,
    height: 7.16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M141.61,55.15c0,2.07-.16,3.17-1.15,3.17s-1.15-1.1-1.15-3.17c0-1.59.22-2.87,1.14-2.87s1.17,1.28,1.17,2.87ZM138.69,55.13c.01,1.99.2,3.9,1.77,3.9s1.76-1.92,1.77-3.9c0-1.64-.19-3.57-1.75-3.57s-1.78,1.93-1.78,3.57"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M145.99,51.71h.59v7.16h-.97l-1.5-5.73c-.09-.32-.15-.65-.2-1.08h-.02c0,.36.02.73.02,1.1v5.71h-.6v-7.16h.97l1.52,5.86c.07.22.12.45.19.78h.01c0-.26-.01-.54-.01-.8v-5.84"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M122.03,35.84v-9.46c-.56.14-3.01.27-3.69-7.37l3.81,3.05v-3.7s-4.19-2.97-4.19-7.66c0-3.37,2.43-6.26,2.43-6.26,0,0,.51-.48,1.06-.07.55.42.27,1.01.27,1.01,0,0-2.07,2.32-2.07,5.1,0,5.04,4.16,6.99,4.16,6.99v5.89l-1.66-1.3c.28,1.41,1.12,5.12,3.27,6.92,2.14-1.79,2.99-5.51,3.27-6.92l-1.66,1.3v-5.89s4.16-1.95,4.16-6.99c0-2.77-2.07-5.1-2.07-5.1,0,0-.28-.59.27-1.01.55-.42,1.06.07,1.06.07,0,0,2.43,2.89,2.43,6.26,0,4.69-4.19,7.66-4.19,7.66v3.7l3.81-3.05c-.69,7.64-3.13,7.51-3.69,7.37v5.51c0,1.07.2,2.06,2.18,2.06,1.76,0,11.96.13,14.2.16,1.92-3.34,3.02-7.2,3.02-11.33,0-12.58-10.2-22.78-22.78-22.78s-22.78,10.2-22.78,22.78,10.2,22.78,22.78,22.78c1.07,0,2.12-.08,3.14-.22-1.48-1.21-6.53-5.65-6.53-9.5Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpalaLight);
export default __webpack_public_path__ + "static/media/Impala-light.69ddae0a8409982301d052845895a50f.svg";
export { ForwardRef as ReactComponent };